import { render, staticRenderFns } from "./Medien.vue?vue&type=template&id=32e4d325&scoped=true"
import script from "./Medien.vue?vue&type=script&lang=js"
export * from "./Medien.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e4d325",
  null
  
)

export default component.exports